module.exports = __webpack_public_path__ + "static/media/Pic6.c92ae92b.png";